import { apiCall } from "./authServices";


export const suggestionListforUser = async () => {
  try {
    const response = await apiCall({
      endpoint:"api/users/get-user-list",
      method: "GET",
       
    });
    return response;
  } catch (error) {
     throw error;
  }
};

export const suggestionListforCourse = async () => {
  try {
    const response = await apiCall({
      endpoint:"api/courses/get-course-list",
      method: "GET",
    });
    return response;
  } catch (error) {
     throw error;
  }
}

export const addSuggestions = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/suggestions/add-suggestion",
      method: "POST",
      payload: payload,
      
    });
    return response;
  } catch (error) {

    throw error;
  }
};

export const getAllSuggestions = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/suggestions/suggestion-stats",
      method: "POST",
     payload: payload
    });
    return response; 
   } catch (error) {
    throw error;
  }
};


export const getSuggestionDetails = async (suggestionId) => {
  try {
    const response = await apiCall({
      endpoint: `api/suggestions/suggestion-details/${suggestionId}`,
      method: "GET",
   

    });
    return response;
  } catch (error) {

    throw error;
  }
}

export const deleteSuggestionDetails = async (suggestionId) => {
  try {
    const response = await apiCall({
      endpoint: `api/suggestions/delete-suggestion/${suggestionId}`,
      method: "DELETE",
   

    });
    return response;
  } catch (error) {
     throw error;
  }
}
